import { render, staticRenderFns } from "./ListOfListsToEdit.vue?vue&type=template&id=40062a9d"
import script from "./ListOfListsToEdit.vue?vue&type=script&lang=ts"
export * from "./ListOfListsToEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports